import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-dark text-gray-300 py-16 border-t border-gray-800" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-175">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-176">
            <div className="bg-white rounded-lg p-3 inline-block mb-6" data-id="element-177">
              <img src="https://cdn.magicpatterns.com/uploads/miiyVjkag3qKFYCybFaUjL/pasted-image.jpg" alt="Compass Recovery Group, LLC" className="h-16 w-auto object-contain" data-id="element-178" />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6" data-id="element-179">
              A professional Receivables & Collections Management Firm dedicated
              to Quality Customer Care and compliance-first recovery solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-180">
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider" data-id="element-181">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-182">
              <li data-id="element-183">
                <a href="#services" className="hover:text-brand-red transition-colors" data-id="element-184">
                  Services
                </a>
              </li>
              <li data-id="element-185">
                <a href="#why-us" className="hover:text-brand-red transition-colors" data-id="element-186">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-187">
                <a href="#about" className="hover:text-brand-red transition-colors" data-id="element-188">
                  About Us
                </a>
              </li>
              <li data-id="element-189">
                <a href="#contact" className="hover:text-brand-red transition-colors" data-id="element-190">
                  Contact
                </a>
              </li>
              <li data-id="element-191">
                <Link to="/portal" className="hover:text-brand-red transition-colors" data-id="element-192">
                  Make a Payment
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Compliance */}
          <div data-id="element-193">
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider" data-id="element-194">
              Legal
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-195">
              <li data-id="element-196">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-197">
                  Compliance Policy
                </a>
              </li>
              <li data-id="element-198">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-199">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-200">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-201">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-202">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-203">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-204">
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider" data-id="element-205">
              Contact Us
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-206">
              <li data-id="element-207">3135 Walden Ave, Suite 4</li>
              <li data-id="element-208">Depew, NY 14043</li>
              <li className="pt-2" data-id="element-209">
                <a href="tel:888-765-3854" className="text-white hover:text-brand-red transition-colors font-semibold" data-id="element-210">
                  888-765-3854
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-sm text-gray-500 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-211">
          <p data-id="element-212">
            &copy; {currentYear} Compass Recovery Group, LLC. All rights
            reserved.
          </p>
          <p data-id="element-213">
            This is an attempt to collect a debt. Any information obtained will
            be used for that purpose.
          </p>
        </div>
      </div>
    </footer>;
}